// extracted by mini-css-extract-plugin
export default {"divInlineBlock":"VisitNotesDetail_divInlineBlock__E6IEy","visitPdfNote":"VisitNotesDetail_visitPdfNote__H6-NV"};